import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CorpCardComponent, CorpLoadingComponent } from "@corporate-tailwind/component";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { PickupPointDto } from "../../../../model/pickup-point.model";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'pickup-point-card-summary',
    imports: [CommonModule, CorpLoadingComponent, CorpCardComponent, TranslateModule],
    templateUrl: './pickup-point-card-summary.component.html',
    styleUrls: ['./pickup-point-card-summary.component.scss'],
    animations: []
})
export class PickupPointCardSummaryComponent implements OnInit, OnDestroy {
    form: FormGroup | null = null;
    pickupPoint: PickupPointDto | null = null;

    constructor(
        public _orderWizardService: OrderWizardService
    ) {
        this.form = this._orderWizardService.formGroup;
        this.pickupPoint = this._orderWizardService.getValue(x=>x.step02);
    }
    ngOnDestroy(): void {
        
    }

    ngOnInit(): void {
    }


}